export default __webpack_public_path__ + "static/media/954.2d6b1310.png";